"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'account.upgrade.title': 'Actualización de Cuenta',
    'account.upgrade.currentGrade': 'Nivel de Cuenta Actual',
    'account.upgrade.selectGrade': 'Tu plan',
    'account.upgrade.save': 'Guardar Cambios',
    'account.upgrade.payNow': 'Pagar Ahora y Actualizar',
    'account.upgrade.downgrade': 'Cambiar a Plan Inferior',
    'account.upgrade.mostPopular': 'Más Popular',
    'account.upgrade.selectPlan': 'Seleccionar Plan',
    'account.upgrade.selected': 'Seleccionado',
    'account.upgrade.success': 'Nivel de cuenta actualizado exitosamente',
    'account.upgrade.paymentInitiated': 'Pago iniciado. Por favor complete el pago para actualizar su cuenta.',
    'account.upgrade.errors.general': 'Error al actualizar el nivel de cuenta',
    'account.upgrade.errors.loadUser': 'Error al cargar información del usuario',
    'account.upgrade.errors.noUser': 'Usuario no encontrado',
    'account.upgrade.credits': 'créditos',
    'account.upgrade.noCredits': 'Sin créditos incluidos',
    'account.upgrade.perMonth': 'por mes',
    'account.upgrade.changePlan': 'Cambiar Plan',
    'account.upgrade.currentPlan': 'Plan Actual',
    'account.upgrade.futureGradeInfo': 'Este plan se activará el',
    'account.upgrade.confirm.title': 'Confirmar Cambio de Plan',
    'account.upgrade.confirm.downgrade': '¿Está seguro de que desea degradar al plan gratuito? Perderá el acceso a las funciones premium.',
    'account.upgrade.confirm.change': '¿Está seguro de que desea cambiar su plan a',
    'account.upgrade.success.changed': 'Su plan ha sido cambiado exitosamente',
    'account.upgrade.success.upgraded': '¡Cuenta actualizada exitosamente!',
    'account.upgrade.errors.changeFailed': 'Error al cambiar su plan',
    'account.upgrade.errors.paymentFailed': 'El pago falló. Por favor, inténtelo de nuevo.',
    'account.upgrade.monthly': 'Mensual',
    'account.upgrade.yearly': 'Anual',
    'account.upgrade.saveMore': 'Ahorra Más',
    'account.upgrade.discount': 'DESC',
    'account.upgrade.save_money_amount': 'Ahorra',
};
